import { dynamicLoader } from '~/utils';

export const LabourRateClassesPage = dynamicLoader({
  name: 'LabourRateClassesPage',
  importFunc: () => import('./labour-rate-classes'),
});
